import {createAsyncThunk} from '@reduxjs/toolkit';
import {
  CampaignTreeType,
  DTCampaignVersionType,
} from 'common/src/modules/campaigns/campaigns.types';
import {
  updateCampaign,
  updateIsCampaignLoading,
  updateVersionId,
  updateVersionNumber,
} from '../campaignTree.slice';
import {
  setNextNodeId,
  setNodesWithDisabledHideOutputButton,
} from '../../campaignLogic/campaignLogic.slice';
import {updateCampaignNodes} from '../../campaignLogic/actions/updateCampaignNodes';
import fetchCampaignPlacements from './fetchCampaignPlacements';
import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import getCampaignNodes from 'common/src/modules/nodes/utils/getCampaignNodes';
import getNodesWithDisabledOutputButton from 'common/src/components/CLCardsMap/CardsMapContainer/utils/collapseNodes/getNodesWithDisabledOutputButton';
import {RootState} from 'common/src/redux/store';

interface LoadCampaignParams {
  campaignId: number;
  version: string | DTCampaignVersionType;
}

const loadCampaignToRedux = createAsyncThunk<void, LoadCampaignParams>(
  'campaignTree/loadCampaignToRedux',
  async ({campaignId, version}, {dispatch, getState}) => {
    dispatch(updateIsCampaignLoading(true));

    try {
      const campaignParams = await campaignsApi.getDTCampaign(campaignId, version);

      const {campaign, loadedVersion, nextNodeId, nodesOrder} = campaignParams;

      const campaignNodes = getCampaignNodes(campaignParams);

      const state = getState() as RootState;
      const hiddenNodeConnectors = state.campaignPage.campaignLogic.hiddenNodeConnectors || [];

      const nodesWithDisabledOutputButton = getNodesWithDisabledOutputButton(
        nodesOrder,
        campaignNodes,
        hiddenNodeConnectors,
      );

      dispatch(updateVersionNumber(loadedVersion.number));
      dispatch(updateVersionId(loadedVersion.id));
      dispatch(setNextNodeId(nextNodeId));
      dispatch(updateCampaign(campaign));

      dispatch(
        updateCampaignNodes({
          connectedNodes: campaignNodes,
          campaignTreeType: CampaignTreeType.Campaign,
        }),
      );

      dispatch(setNodesWithDisabledHideOutputButton(nodesWithDisabledOutputButton));

      await dispatch(
        fetchCampaignPlacements({
          campaignId,
          campaignVersionId: loadedVersion.id,
        }),
      );
    } finally {
      dispatch(updateIsCampaignLoading(false));
    }
  },
);

export default loadCampaignToRedux;
